<template>
  <div class="product-detail">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="商品详情"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />

    <!-- 商品主图 -->
    <div class="product-image">
      <img :src="product.image" :alt="product.title">
    </div>

    <!-- 商品信息 -->
    <div class="product-info">
      <div class="price-section">
        <div>
          <span class="current-price">¥{{ product.price }}</span>
          <span class="original-price">¥{{ product.originalPrice }}</span>
        </div>
        <div>
          <span class="sales">月销 {{ product.sales }}</span>
        </div>
      </div>
      <h1 class="title">{{ product.title }}</h1>
    </div>

    <!-- 商品选项 -->
    <div class="options">
      <div class="option-row">
        <div class="option-label">已选</div>
        <div class="option-content" @click="showSku = true">
          <div class="right-content">
            <span>{{ product.specs.join('，') }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      
      <div class="option-row">
        <div class="option-label">送至</div>
        <div class="option-content">
          <div class="right-content">
            <span>广州市天河区</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <div class="option-row">
        <div class="option-label">承诺</div>
        <div class="option-content">
          <div class="right-content">
            <div class="tags-right">
          <van-tag plain type="danger" class="service-tag" v-for="(tag, index) in product.tags" :key="index">
            {{ tag }}
          </van-tag>
        </div>
          </div>
        </div>
      </div>

    </div>


    <!-- 商品规格 -->
    <div class="specs-section">
      <div class="section-title">商品参数</div>
      <div class="specs-list">
        <div class="spec-item" v-for="(spec, key) in product.parameters" :key="key">
          <span class="spec-label">{{ key }}</span>
          <span class="spec-value">{{ spec }}</span>
        </div>
      </div>
    </div>

    <!-- 店铺信息 -->
    <div class="shop-info">
      <van-cell center>
        <template #title>
          <div class="shop-title">
            <van-image
              round
              width="40"
              height="40"
              src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
            />
            <span class="shop-name">官方自营店</span>
          </div>
        </template>
        <template #right-icon>
          <van-button size="small" plain type="danger">进店逛逛</van-button>
        </template>
      </van-cell>
    </div>

    <!-- 底部操作栏 -->
    <van-goods-action>
      <van-goods-action-icon icon="shop-o" text="店铺" />
      <van-goods-action-icon icon="chat-o" text="客服" />
      <van-goods-action-icon 
        icon="cart-o" 
        text="购物车" 
        :badge="cartCount"
        to="/cart"
      />
      <van-goods-action-button type="warning" text="加入购物车" @click="addToCart" />
      <van-goods-action-button type="danger" text="立即购买" />
    </van-goods-action>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data() {
    return {
      showSku: false,
      cartCount: 0,
      product: {
        id: 1,
        title: '游戏笔记本',
        price: 5999,
        originalPrice: 6999,
        desc: '16+512GB RTX3060',
        image: require('@/assets/computer1.png'),
        stock: 10,
        tags: ['限时特惠', '新品', '爆款'],
        specs: ['15.6英寸', '16G内存', '512G固态'],
        parameters: {
          '商品名称': '游戏笔记本电脑',
          '处理器': 'i7-12700H',
          '内存容量': '16GB',
          '硬盘容量': '512GB SSD',
          '显卡型号': 'RTX 3060'
        }
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    addToCart() {
      // 构建购物车商品数据
      const cartItem = {
        id: this.product.id,
        title: this.product.title,
        desc: this.product.desc,
        price: this.product.price,
        count: 1,
        stock: this.product.stock,
        image: this.product.image
      }
      
      // 获取现有购物车数据
      let cartList = localStorage.getItem('cartList')
      if (cartList) {
        cartList = JSON.parse(cartList)
        // 检查商品是否已在购物车中
        const existItem = cartList.find(item => item.id === cartItem.id)
        if (existItem) {
          existItem.count++
        } else {
          cartList.push(cartItem)
        }
      } else {
        cartList = [cartItem]
      }
      
      // 保存到本地存储
      localStorage.setItem('cartList', JSON.stringify(cartList))
      
      // 更新购物车数量
      this.cartCount = cartList.length
      
      // 提示用户
      this.$toast.success('已加入购物车')
      
      // 跳转到购物车页面
      this.$router.push('/cart')
    }
  },
  // 获取购物车数量
  mounted() {
    const cartList = localStorage.getItem('cartList')
    if (cartList) {
      this.cartCount = JSON.parse(cartList).length
    }
  }
}
</script>

<style scoped>
/* 基础布局样式 */
.product-detail {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 30px;
}

/* 商品图片 */
.product-image {
  width: 100%;
  height: 250px;
  background: #fff;
  margin-bottom: -5px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 商品信息 */
.product-info {
  background: #fff;
  padding: 15px;
  margin-bottom: 5px;
}

.price-section {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
}

.current-price {
  font-size: 24px;
  color: #ff1b3d;
  font-weight: bold;
  margin-right: 10px;
}

.original-price {
  color: #999;
  text-decoration: line-through;
  margin-right: 15px;
  font-size: 14px;
}

.sales {
  color: #999;
  font-size: 12px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4;
  margin: 0;
  text-align: left;
}

/* 选项行样式 */
.options {
  background: #fff;
  margin-bottom: 8px;
}

.option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
}

.option-label {
  color: #323233;
  font-size: 14px;
}

.option-content {
  color: #8a8a8a;
  font-size: 14px;
}

.right-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 标签样式 */
.tags-right {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.service-tag {
  font-size: 12px;
}

/* 商品参数样式 */
.specs-section {
  background: #fff;
  margin-bottom: 8px;
}

.section-title {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: bold;
  color: #323233;
  border-bottom: 1px solid #f5f5f5;
}

.specs-list {
  padding: 0 16px;
}

.spec-item {
  display: flex;
  padding: 12px 0;
  font-size: 14px;
  border-bottom: 1px solid #f5f5f5;
}

.spec-item:last-child {
  border-bottom: none;
}

.spec-label {
  width: 100px;
  color: #969799;
}

.spec-value {
  flex: 1;
  color: #323233;
}

/* 店铺信息 */
.shop-info {
  background: #fff;
  margin-bottom: 8px;
}

.shop-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.shop-name {
  font-size: 14px;
  font-weight: bold;
}

/* 导航栏样式 */
:deep(.van-nav-bar) {
  background-color: #fff;
}

:deep(.van-nav-bar__title) {
  color: #323233;
}

:deep(.van-icon) {
  color: #323233 !important;
}

/* 底部操作栏样式 */
:deep(.van-goods-action) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>

